module.exports = __webpack_public_path__ + "img/image27.9fd000f4.jpg";